import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL, ENDPOINTS, getData, postData } from "../../constants/api";
import { CURRENT_DATE } from "../../constants";
import { useNavigate } from "react-router-dom";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { notification } from "antd";

export default function CustomReceiptForm2({route}) {
  const navigate=useNavigate();
  const [form, setForm] = useState({
    student: {
      id: "",
      name: "",
      mother: "",
      class: "",
      school: "",
      guardianName: "",
      guardianPhone: "",
      parent_id:null,
    },
    payment: {
      fee_id: null,
      fee_name: "",
      year_id: null,
      year_name: "",
      method_id: null,
      method_name: "",
      amount: "0.00",
      usd: "0",
      date: CURRENT_DATE,
      rvno: null,
      force: "NO",
      note: "",
    },
    months: [], 
  });

  
  const [feeOptions, setFeeOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [methodOptions, setMethodOptions] = useState([]);
  const [studentQuery, setStudentQuery] = useState("");
  const [studentOptions, setStudentOptions] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);

   const token = getToken();
  const userId = decodeToken(token, "id");
  
  const fetchDropdown = async (input_id, setter, stateField) => {
    try {
      const url=`${API_URL}/${ENDPOINTS.SYS}/get-dropdown/${input_id}`;
      const options = await getData(url);
      setter(options);

      // Set default selected
      const selectedOption = options.find(o => o.selected === 'selected') || options[0];
      setForm(prev => ({
        ...prev,
        payment: {
          ...prev.payment,
          [`${stateField}_id`]: selectedOption?.value,
          [`${stateField}_name`]: selectedOption?.text,
        },
      }));
    } catch (err) {
      console.error(`Error loading dropdown ${input_id}:`, err);
    }
  };

  const searchStudents = async (q) => {
  if (!q || q.length < 2) {
    setStudentOptions([]);
    return;
  }

  try {
    setLoadingStudents(true);
    var searchurl;
    if (route==='student-bus-receipt-form') {
      searchurl=`${API_URL}/${ENDPOINTS.SYS}/autocomplete/4717?query=${q}`;
      
    }else{
      searchurl=`${API_URL}/${ENDPOINTS.SYS}/autocomplete/4685?query=${q}`;
    }
    const res = await getData(
      searchurl,
    
    );

    if (res) {
      setStudentOptions(res || []);
    }
  } catch (e) {
    console.error(e);
  } finally {
    setLoadingStudents(false);
  }
};
  const handleStudentSelect = (student) => {
  setStudentQuery(`${student.id}`);
  setStudentOptions([]);
  setForm(prev => ({
  ...prev,
  student: { ...prev.student, id: student.id }
}));

};


  useEffect(() => {
    // Call each dropdown separately
    if (route==='student-bus-receipt-form') {

      fetchDropdown(4348, setFeeOptions, "fee");
      fetchDropdown(4350, setYearOptions, "year");
      fetchDropdown(4341, setMethodOptions, "method");
    }else{

      fetchDropdown(4189	, setFeeOptions, "fee");
      fetchDropdown(4191, setYearOptions, "year");
      fetchDropdown(4182, setMethodOptions, "method");
    }
    
  }, []);

  const fetchStudentAndMonths = async () => {
    if (!form.payment.fee_id || !form.payment.year_id || !form.student.id) return;
    // console.log("student id: to fetch ",form.student.id)
    var fetchUrl;
    if (route==='student-bus-receipt-form') {
      fetchUrl=`${API_URL}/${ENDPOINTS.SYS}/activityReport/student-bus-balance-info`;
    }else{
      fetchUrl=`${API_URL}/${ENDPOINTS.SYS}/activityReport/student-balance-information`;
    }
    try {
      const res = await postData(fetchUrl, 
        {
          student_id: form.student.id,
          fee_id: form.payment.fee_id,
          year_id: form.payment.year_id,
        }
      );
      if (res.success !== 1 || !res.data) return;

    
     const studentInfo = res.data.find(d => d.title === "student_info")?.fields;
    const paidData = res.data.find(d => d.title === "paid_info");
    let paidMonths = [];
    if (paidData) {
      if (paidData.table) {
        paidMonths = paidData.table;
      } else if (paidData.fields) {
        paidMonths = [paidData.fields]; // wrap single object in array
      }
    }
    const allMonths = res.data.find(d => d.title === "all_months")?.table || [];
    const otherFields = res.data.find((d) => d.title === "other_fields")?.fields || {};

    const months = allMonths.map(m => {
      const paid = paidMonths.find(p => p.month_id === m.id);
      return paid
        ? {
            rv: paid.rv,
            amt: paid.amt,
            m: m.name,
            c: true,
            disabled: true,  // already paid → always disabled
            month_id: m.id,
            year_id: form.payment.year_id,
          }
        : {
            rv: "",
            amt: "0.00",
            m: m.name,
            c: false,
            disabled: false, // unpaid → can check
            month_id: m.id,
            year_id: form.payment.year_id,
          };
    });

    setForm((prev) => ({
        ...prev,
        student: { ...prev.student, ...studentInfo },
        months,
        payment: {
          ...prev.payment,
          rvno: otherFields.rvno || "",
          amount: otherFields.amount || "",
        },
      }));
    } catch (err) {
      console.error("Error loading student & months:", err);
    }
  };

  // Trigger fetch when fee_id or year_id changes
  useEffect(() => {
    fetchStudentAndMonths();
  }, [form.student.id, form.payment.fee_id, form.payment.year_id]);


  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      payment: {
        ...prev.payment,
        [name]: value,
      },
    }));
  };

  const handleMonthChange = (index, field, value) => {
  const newMonths = [...form.months];

  // Only allow toggling if month is not disabled
  if (!newMonths[index].disabled) {
    newMonths[index][field] = value;
    setForm(prev => ({ ...prev, months: newMonths }));
  }
};

  const handleSubmit=async ()=>{
   
    const month_ids=form.months.filter((month)=>month.c==true && month.disabled==false).map((m)=>m.month_id);
     if (!month_ids.length>0) {
      notification.error({ message: "Fadlan Dooro bilaha" });
      return;
    }
    const payload={
      student_id:form.student.id,
      fee_id:form.payment.fee_id,
      amount:form.payment.amount,
      discount:0,
      tax:0,
      bank_id:form.payment.method_id,
      month_id:month_ids,
      year_id:form.payment.year_id,
      bank_ref_no:"",
      receipt_tell:form.payment.usd,
      user_id:userId,
      description:form.payment.note,
      date:form.payment.date,
      ref_no:form.payment.rvno,
      parent_id:form.student.parent_id,
      force:form.payment.force
    }
    var insertUrl;
    if (route==='student-bus-receipt-form') {
      insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/collect-bus-fee`;
    }else{
      insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/collect-fee`;
    }
    const response = await postData(insertUrl, payload);
     if (response.success === '1' || response.success === 1) {
     setStudentQuery("");      // 🔑 clear autocomplete input
    setStudentOptions([]);    // clear dropdown list

       setForm(prev => ({
    student: {
      id: "",
      name: "",
      mother: "",
      class: "",
      school: "",
      guardianName: "",
      guardianPhone: "",
      parent_id: null,
    },
    payment: {
      ...prev.payment,     // ✅ KEEP fee & year
      amount: "0.00",
      rvno: null,
      note: "",
    },
    months: [],
  }));
        notification.success({ message: response.message });
        if (response.insertId && response.print_route) {
            const url = `/${response.print_route}/${response.insertId}`;
            console.log("url:  to print ",url);
            window.open(url, "_blank");
          }
     }else
      {
         notification.error({ message: response.message || 'An error occurred' });
     }
  }

  return (
    <div className="container-fluid mt-3">
      {/* TOP BAR */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold">Lacag bixinta</h5>
        {/* <div className="d-flex gap-2">
          <input className="form-control" placeholder="Enter Invoice To Edit" style={{ width: 260 }} />
          <button className="btn btn-info text-white px-4">Raadi</button>
          <button className="btn btn-danger px-4">Back</button>
        </div> */}
      </div>

      <div className="row">
        {/* LEFT COLUMN */}
        <div className="col-md-8">
          {/* Student Information */}
          <div className="fw-semibold mb-1">Student Information</div>
          <hr className="mt-1 mb-3" />
          <div className="row g-3">
            <div className="col-md-3">
              <label className="form-label">Student ID</label>
              <div className="position-relative">
  <input
    className="form-control"
    placeholder="Search Student ID or Name"
    value={studentQuery}
    onChange={(e) => {
      setStudentQuery(e.target.value);
      searchStudents(e.target.value);
    }}
  />

  {studentOptions.length > 0 && (
    <ul
      className="list-group position-absolute w-100"
      style={{ zIndex: 1000, maxHeight: 220, overflowY: "auto" }}
    >
      {studentOptions.map((s) => (
        <li
          key={s.id}
          className="list-group-item list-group-item-action"
          onClick={() => handleStudentSelect(s)}
          style={{ cursor: "pointer" }}
        >
          <strong>{s.id}</strong> – {s.name}
          <div className="small text-muted">{s.class}</div>
        </li>
      ))}
    </ul>
  )}

  {loadingStudents && (
    <div className="small text-muted mt-1">Searching...</div>
  )}
</div>

            </div>
            <div className="col-md-6">
              <label className="form-label">Student Name</label>
              <input className="form-control" value={form.student.name} disabled />
            </div>
            <div className="col-md-3">
              <label className="form-label">Mother</label>
              <input className="form-control" value={form.student.mother} disabled />
            </div>
            <div className="col-md-3">
              <label className="form-label">Class</label>
              <input className="form-control" value={form.student.class} disabled />
            </div>
            <div className="col-md-3">
              <label className="form-label">School</label>
              <input className="form-control" value={form.student.school} disabled />
            </div>
            <div className="col-md-3" hidden={true}>
              <label className="form-label">Parent ID</label>
              <input className="form-control" value={form.student.parent_id} disabled />
            </div>
            <div className="col-md-3">
              <label className="form-label">Guardian Name</label>
              <input className="form-control" value={form.student.guardianName} disabled />
            </div>
            <div className="col-md-3">
              <label className="form-label">Guardian Phone</label>
              <input className="form-control" value={form.student.guardianPhone} disabled />
            </div>
          </div>

          {/* PAYMENT INFO */}
          <div className="fw-semibold mt-4 mb-1">Payment Information</div>
          <hr className="mt-1 mb-3" />
          <div className="row g-3">
            {/* Fee Dropdown */}
            <div className="col-md-4">
              <label className="form-label">Fee</label>
              <select
                className="form-select"
                name="fee_id"
                value={form.payment.fee_id || ""}
                onChange={(e) =>
                  setForm(prev => ({
                    ...prev,
                    payment: {
                      ...prev.payment,
                      fee_id: Number(e.target.value),
                      fee_name: feeOptions.find(f => f.id === Number(e.target.value))?.name,
                    },
                  }))
                }
              >
                {feeOptions.map(f => (
                  <option key={f.value} value={f.value}>{f.text}</option>
                ))}
              </select>
            </div>

            {/* Year Dropdown */}
            <div className="col-md-4">
              <label className="form-label">Year</label>
              <select
                className="form-select"
                name="year_id"
                value={form.payment.year_id || ""}
                onChange={(e) =>
                  setForm(prev => ({
                    ...prev,
                    payment: {
                      ...prev.payment,
                      year_id: Number(e.target.value),
                      year_name: yearOptions.find(y => y.value === Number(e.target.value))?.name,
                    },
                  }))
                }
              >
                {yearOptions.map(y => (
                  <option key={y.value} value={y.value}>{y.text}</option>
                ))}
              </select>
            </div>

            {/* Amount */}
            <div className="col-md-4">
              <label className="form-label">Amount</label>
              <input className="form-control" value={form.payment.amount} disabled />
            </div>

            {/* Method Dropdown */}
            <div className="col-md-4">
              <label className="form-label">Method</label>
              <select
                className="form-select"
                name="method_id"
                value={form.payment.method_id || ""}
                onChange={(e) =>
                  setForm(prev => ({
                    ...prev,
                    payment: {
                      ...prev.payment,
                      method_id: Number(e.target.value),
                      method_name: methodOptions.find(m => m.value === Number(e.target.value))?.name,
                    },
                  }))
                }
              >
                {methodOptions.map(m => (
                  <option key={m.value} value={m.value}>{m.text}</option>
                ))}
              </select>
            </div>

            {/* USD, Date, RVNO, Force, Note */}
            <div className="col-md-4">
              <label className="form-label">USD *</label>
              <input className="form-control" name="usd" value={form.payment.usd} onChange={handlePaymentChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Date</label>
              <input className="form-control" type="date" name="date" value={form.payment.date} onChange={handlePaymentChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">RVNO</label>
              <input className="form-control" name="rvno" value={form.payment.rvno} onChange={handlePaymentChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Force</label>
              <select className="form-select" name="force" value={form.payment.force} onChange={handlePaymentChange}>
                <option>NO</option>
                <option>YES</option>
              </select>
            </div>
            <div className="col-md-12">
              <label className="form-label">Note</label>
              <textarea className="form-control" rows="2" name="note" value={form.payment.note} onChange={handlePaymentChange}></textarea>
            </div>
          </div>
        </div>

        <div className="col-md-4">
  <div className="fw-semibold mb-1">Months Information</div>
  <hr className="mt-1 mb-3" />
  {form.months.map((row, i) => (
    <div className="row g-2 align-items-center mb-2" key={i}>
      <div className="col-4">
        <input
          className="form-control"
          value={row.rv}
          onChange={(e) => handleMonthChange(i, "rv", e.target.value)}
          disabled={row.disabled} // disable only paid months
        />
      </div>
      <div className="col-4">
        <input
          className="form-control text-end"
          value={row.amt}
          onChange={(e) => handleMonthChange(i, "amt", e.target.value)}
          disabled={row.disabled} // disable only paid months
        />
      </div>
      <div className="col-4">
        <div className="form-check m-0">
          <input
            type="checkbox"
            className="form-check-input"
            checked={row.c}
            disabled={row.disabled} // disable only paid months
            onChange={(e) => handleMonthChange(i, "c", e.target.checked)}
          />
          <label className="form-check-label ms-1">{row.m}</label>
        </div>
      </div>
    </div>
  ))}
</div>

      </div>

      {/* MAIN CARD */}
      <div className="card p-3">
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button className="btn btn-success px-4" onClick={handleSubmit}>$ Collect Fees</button>
          <button className="btn btn-secondary px-4" 
          onClick={()=>
            route==='student-bus-receipt-form'? navigate('/form-report/student-bus-sponser') : navigate('/form-report/sponser-report')
            }>Guardian</button>
          <button className="btn btn-warning px-4"
          onClick={()=>
            route==='student-bus-receipt-form'? navigate('/form-report/cancel-bus-fee-receipt') : navigate('/form-report/cancel-fee-receipt')
          }
          >Edit/Cancel</button>
          <button className="btn btn-primary px-4">History</button>
        </div>
      </div>
    </div>
  );
}
